var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.window.is.mobile)?_c('core-filter-input-text',{staticClass:"filter-text-wrapper",attrs:{"filter":_vm.filter,"placeholder":"Quick search..."},on:{"ready":_vm.onReady}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }